module.exports = __webpack_public_path__ + "da816eabe5524958f2f67651bacd4dab.svg";